interface IMenu {
  title: string;
  url: string;
}
interface IInfo {
  title: string;
  value: string;
}

export const links: IMenu[] = [
  {
    title: "landing.links.about_us",
    url: "/about-us",
  },
  {
    title: "landing.links.backtest",
    url: "/history",
  },
  {
    title: "landing.links.features",
    url: "/home/#features",
  },
  {
    title: "landing.links.plans",
    url: "/pricing",
  },
  {
    title: "landing.links.blogs",
    url: "/blogs",
  },
  {
    title: "landing.links.contact_us",
    url: "/contact-us",
  },
];

export const infoStatistics: IInfo[] = [
  {
    title: "landing.info.statistics.active_customers",
    value: "850+",
  },
  {
    title: "landing.info.statistics.bid_accuracy",
    value: "82%",
  },
  {
    title: "landing.info.statistics.average_deposit",
    value: "18000",
  },
  {
    title: "landing.info.statistics.live_support",
    value: "24/7",
  },
];
export const trustedInfoStatistics: IInfo[] = [
  {
    title: "landing.trustedInfo.statistics.customers",
    value: "800+",
  },
  {
    title: "landing.trustedInfo.statistics.exchange_accounts",
    value: "200+",
  },
];

export const benefits = [
  {
    title: "landing.benefits.items.spot_trading.title",
    desc: "landing.benefits.items.spot_trading.description",
    icon: "icon-ocean",
    link: "https://app.sarafrobot.com/en/blogs/best-ai-trading-bot-for-2025-automated-trading-made-easy",
  },
  {
    title: "landing.benefits.items.liquidation.title",
    desc: "landing.benefits.items.liquidation.description",
    icon: "icon-box",
    link: "https://app.sarafrobot.com/en/blogs/never-get-liquidated-anymore-protect-your-investments",
  },
  {
    title: "landing.benefits.items.risk_management.title",
    desc: "landing.benefits.items.risk_management.description",
    icon: "icon-warning",
  },
  {
    title: "landing.benefits.items.support.title",
    desc: "landing.benefits.items.support.description",
    icon: "icon-support",
    link: "https://app.sarafrobot.com/en/blogs/your-partner-in-finance-247-customer-assistance",
  },
  {
    title: "landing.benefits.items.profit_targets.title",
    desc: "landing.benefits.items.profit_targets.description",
    icon: "icon-cup",
  },
  {
    title: "landing.benefits.items.templates.title",
    desc: "landing.benefits.items.templates.description",
    icon: "icon-share",
  },
];

export const ChooseForYou = [
  {
    title: "Overwhelmed by Complex Trading?",
    desc: "No worries! Saraf Robot comes pre-loaded with expert-tested strategies. Just plug in and let it trade for you—no steep learning curve required!",
  },
  {
    title: "Worried About Risk?",
    desc: "Saraf Robot’s smart strategies are built to thrive in both up and down markets, helping you protect your investments and grow steadily.",
  },
  {
    title: "Too Busy to Trade?",
    desc: "Stay focused on your life while Saraf Robot works 24/7 in the background. Sit back, relax, and watch your investments grow—no need to quit your day job.",
  },
];
export const exchanges = [
  {
    icon: "/landing/exchanges/binance.png",
    url: "https://www.binance.com/",
  },
  {
    icon: "/landing/exchanges/bybit.png",
    url: "https://www.bybit.com/",
  },
  {
    icon: "/landing/exchanges/okx.png",
    url: "https://www.okx.com/",
  },
  {
    icon: "/landing/exchanges/kraken.png",
    url: "https://www.kraken.com/",
  },
];

export const Team = [
  {
    name: "Muslihiddin Hayitbaev",
    role: "landing.team.muslihiddin.role",
    image: "/landing/team/muslihiddin.png",
  },
  {
    name: "Mamur Bakhromov",
    role: "landing.team.mamur.role",
    image: "/landing/team/mm.webp",
  },
  {
    name: "Jakhongir Sagdullaev",
    role: "landing.team.jakhongir.role",
    image: "/landing/team/jj.webp",
  },
  {
    name: "Eldorbek Sotvoldiev",
    role: "landing.team.eldor.role",
    image: "/landing/team/eldor.png",
  },
];
export const Steps = [
  {
    id: 1,
    title: "landing.start_steps.steps.link_exchange",
    description: "landing.start_steps.steps.link_exchange_description",
    action: true,
    image: "/landing/images/exchanges.webp",
  },
  {
    id: 2,
    title: "landing.start_steps.steps.set_up_bot",
    description: "landing.start_steps.steps.set_up_bot_description",
    action: false,
    image: "/landing/images/create-bot.webp",
  },
  {
    id: 3,
    title: "landing.start_steps.steps.let_bots_handle_tasks",
    description: "landing.start_steps.steps.let_bots_handle_tasks_description",
    action: false,
    image: "/landing/images/trades.webp",
  },
];

export const Plans = [
  {
    title: "Free",
    trading_position: 1,
    trading_pairs: ["BTC", "ETH"],
    strategy: 1,
    commission: 0.4,
    price: 0,
    highlighted: false,
  },
  {
    title: "Starter",
    trading_position: 2,
    trading_pairs: 2,
    strategy: 1,
    commission: 0.25,
    price: 299,
    highlighted: false,
  },
  {
    title: "Standart",
    trading_position: 8,
    trading_pairs: 15,
    strategy: 2,
    commission: 0.15,
    price: 599,
    highlighted: true,
  },
  {
    title: "Pro",
    trading_position: 16,
    trading_pairs: 18,
    strategy: 2,
    commission: 0.05,
    price: 999,
    highlighted: false,
  },
];

export const Blogs = [
  {
    id: 1,
    title:
      "Unauthorized Account Registrations Using Email Addresses from 3rd Party Sources",
    image:
      "https://images.prismic.io/3commas-blog/ZqOYgx5LeNNTxhhz_ImportantInformation.jpg?auto=format,compress",
    url: "/blogs/1",
    created_at: new Date(),
  },
  {
    id: 2,
    title: "Forex Trading Bot: Quick Guide",
    image:
      "https://images.prismic.io/3commas-blog/e4b794a0-144f-4147-a984-e91f0e5a50ca_The+Best+Forex+Trading+Bot+%282%29+%281%29.jpg?auto=compress,format",
    url: "/blogs/1",
    created_at: new Date(),
  },
  {
    id: 3,
    title: "Building a Crypto Trading Bot — 2024 How to Guide",
    image:
      "https://images.prismic.io/3commas-blog/MjJjMDNkNjktMDE4Ny00YTM0LWI1NTYtY2Y5M2I1YmFjOGJj_cryptocurrencyeducation.jpg?auto=compress,format&rect=0,0,1080,721&w=1080&h=721",
    url: "/blogs/1",
    created_at: new Date(),
  },
  {
    id: 4,
    title: "10 Best Crypto Trading Bot Strategies 2024",
    image:
      "https://images.prismic.io/3commas-blog/75c9a50d-c1fd-4bb1-bb9b-ed5e8ce2968a_10+Best+Trading+Bot+Strategies+2022.jpg?auto=compress,format&rect=0,0,1792,1220&w=1792&h=1220",
    url: "/blogs/1",
    created_at: new Date(),
  },
  {
    id: 5,
    title: "Best Crypto Trading Tools  —  2024 Reviews & Comparison",
    image:
      "https://images.prismic.io/3commas-blog/59c3430e-346f-4450-a6b8-30ee61ed3076_Best+crypto+trading+tools.jpg?auto=compress,format",
    url: "/blogs/1",
    created_at: new Date(),
  },
];

export const faqList = [
  {
    id: 6,
    question: "landing.faq.questions.what_is_saraf_robot",
    answer: "landing.faq.answers.what_is_saraf_robot",
    file: null,
  },
  {
    id: 7,
    question: "landing.faq.questions.how_do_the_robots_work",
    answer: "landing.faq.answers.how_do_the_robots_work",
    file: null,
  },
  {
    id: 8,
    question: "landing.faq.questions.how_is_my_exchange_information_stored",
    answer: "landing.faq.answers.how_is_my_exchange_information_stored",
    file: null,
  },
  {
    id: 9,
    question:
      "landing.faq.questions.subscriptions_flexible_plans_for_every_trader",
    answer: "landing.faq.answers.subscriptions_flexible_plans_for_every_trader",
    file: null,
  },
  {
    id: 10,
    question: "landing.faq.questions.what_cryptocurrencies_can_i_trade",
    answer: "landing.faq.answers.what_cryptocurrencies_can_i_trade",
    file: null,
  },
  {
    id: 11,
    question: "landing.faq.questions.can_i_stop_the_robots",
    answer: "landing.faq.answers.can_i_stop_the_robots",
    file: null,
  },
  {
    id: 12,
    question:
      "landing.faq.questions.referral_program_earn_more_by_inviting_friends",
    answer:
      "landing.faq.answers.referral_program_earn_more_by_inviting_friends",
    file: null,
  },
  {
    id: 13,
    question: "landing.faq.questions.how_reliable_are_the_strategies",
    answer: "landing.faq.answers.how_reliable_are_the_strategies",
    file: null,
  },
  {
    id: 14,
    question: "landing.faq.questions.can_i_change_my_plan",
    answer: "landing.faq.answers.can_i_change_my_plan",
    file: null,
  },
];

export const historyData = {
  "2020": {
    smart_flow: {
      info: {
        total_orders: 518,
        daily_average_trades: 1.42,
        min_balance: 877.14,
        max_balance: 2213.0,
        absolute_drawdown: 17.9,
        sharpe_ratio: 2.69,
      },
      data: [
        {
          month: "January",
          total_profit: 54.29,
          accum_profit_price: 1054.29,
          profit: 5.43,
          accum_profit_percentage: 5.43,
        },
        {
          month: "February",
          total_profit: 147.8,
          accum_profit_price: 1202.09,
          profit: 14.02,
          accum_profit_percentage: 20.21,
        },
        {
          month: "March",
          total_profit: 101.13,
          accum_profit_price: 1100.96,
          profit: -8.41,
          accum_profit_percentage: 10.1,
        },
        {
          month: "April",
          total_profit: 65.78,
          accum_profit_price: 1166.74,
          profit: 5.97,
          accum_profit_percentage: 16.67,
        },
        {
          month: "May",
          total_profit: 9.05,
          accum_profit_price: 1157.69,
          profit: -0.78,
          accum_profit_percentage: 15.78,
        },
        {
          month: "June",
          total_profit: 92.28,
          accum_profit_price: 1249.97,
          profit: 7.97,
          accum_profit_percentage: 25.0,
        },
        {
          month: "July",
          total_profit: 251.45,
          accum_profit_price: 1501.42,
          profit: 20.12,
          accum_profit_percentage: 50.14,
        },
        {
          month: "August",
          total_profit: 414.36,
          accum_profit_price: 1915.79,
          profit: 27.6,
          accum_profit_percentage: 91.58,
        },
        {
          month: "September",
          total_profit: 27.79,
          accum_profit_price: 1943.58,
          profit: 1.45,
          accum_profit_percentage: 94.36,
        },
        {
          month: "October",
          total_profit: 19.37,
          accum_profit_price: 1962.94,
          profit: 1.0,
          accum_profit_percentage: 96.29,
        },
        {
          month: "November",
          total_profit: 119.64,
          accum_profit_price: 1843.3,
          profit: -6.09,
          accum_profit_percentage: 84.33,
        },
        {
          month: "December",
          total_profit: 31.86,
          accum_profit_price: 1875.16,
          profit: 1.73,
          accum_profit_percentage: 87.52,
        },
      ],
    },
    candle_master: {
      info: {
        total_orders: 691,
        daily_average_trades: 1.89,
        min_balance: 956.78,
        max_balance: 4762.83,
        absolute_drawdown: 58.66,
        sharpe_ratio: 0.9,
      },
      data: [
        {
          month: "January",
          total_profit: 62.99,
          accum_profit_price: 1062.99,
          profit: 6.3,
          accum_profit_percentage: 6.3,
        },
        {
          month: "February",
          total_profit: 210.22,
          accum_profit_price: 1273.21,
          profit: 19.78,
          accum_profit_percentage: 27.32,
        },
        {
          month: "March",
          total_profit: 209.3,
          accum_profit_price: 1482.51,
          profit: 16.44,
          accum_profit_percentage: 48.25,
        },
        {
          month: "April",
          total_profit: 239.81,
          accum_profit_price: 1722.32,
          profit: 16.18,
          accum_profit_percentage: 72.23,
        },
        {
          month: "May",
          total_profit: 282.15,
          accum_profit_price: 2004.47,
          profit: 16.38,
          accum_profit_percentage: 100.45,
        },
        {
          month: "June",
          total_profit: 48.44,
          accum_profit_price: 2052.91,
          profit: 2.42,
          accum_profit_percentage: 105.29,
        },
        {
          month: "July",
          total_profit: 1109.56,
          accum_profit_price: 3162.47,
          profit: 54.05,
          accum_profit_percentage: 216.25,
        },
        {
          month: "August",
          total_profit: 1485.0,
          accum_profit_price: 4647.47,
          profit: 46.96,
          accum_profit_percentage: 364.75,
        },
        {
          month: "September",
          total_profit: 1451.0,
          accum_profit_price: 3196.47,
          profit: -31.22,
          accum_profit_percentage: 219.65,
        },
        {
          month: "October",
          total_profit: 1203.32,
          accum_profit_price: 1993.15,
          profit: -37.65,
          accum_profit_percentage: 99.31,
        },
        {
          month: "November",
          total_profit: 1167.59,
          accum_profit_price: 3160.74,
          profit: 58.58,
          accum_profit_percentage: 216.07,
        },
        {
          month: "December",
          total_profit: 891.77,
          accum_profit_price: 2268.97,
          profit: -28.21,
          accum_profit_percentage: 126.9,
        },
      ],
    },
    ewo_strike: {
      info: {
        total_orders: 180,
        daily_average_trades: 0.49,
        min_balance: 714.37,
        max_balance: 2426.71,
        absolute_drawdown: 37.66,
        sharpe_ratio: 1.17,
      },
      data: [
        {
          month: "January",
          total_profit: 13.85,
          accum_profit_price: 1013.85,
          profit: 1.39,
          accum_profit_percentage: 1.39,
        },
        {
          month: "February",
          total_profit: 137.03,
          accum_profit_price: 1150.88,
          profit: 13.52,
          accum_profit_percentage: 15.09,
        },
        {
          month: "March",
          total_profit: 274.62,
          accum_profit_price: 876.26,
          profit: -23.86,
          accum_profit_percentage: -12.37,
        },
        {
          month: "April",
          total_profit: 86.4,
          accum_profit_price: 962.66,
          profit: 9.86,
          accum_profit_percentage: -3.73,
        },
        {
          month: "May",
          total_profit: 75.15,
          accum_profit_price: 1037.81,
          profit: 7.81,
          accum_profit_percentage: 3.78,
        },
        {
          month: "June",
          total_profit: 44.19,
          accum_profit_price: 1082.0,
          profit: 4.26,
          accum_profit_percentage: 8.2,
        },
        {
          month: "July",
          total_profit: 341.47,
          accum_profit_price: 1423.47,
          profit: 31.56,
          accum_profit_percentage: 42.35,
        },
        {
          month: "August",
          total_profit: 164.43,
          accum_profit_price: 1587.9,
          profit: 11.55,
          accum_profit_percentage: 58.79,
        },
        {
          month: "September",
          total_profit: 456.12,
          accum_profit_price: 2044.02,
          profit: 28.72,
          accum_profit_percentage: 104.4,
        },
        {
          month: "October",
          total_profit: 210.62,
          accum_profit_price: 1833.4,
          profit: -10.3,
          accum_profit_percentage: 83.34,
        },
        {
          month: "November",
          total_profit: 529.09,
          accum_profit_price: 2362.49,
          profit: 28.86,
          accum_profit_percentage: 136.25,
        },
        {
          month: "December",
          total_profit: 126.58,
          accum_profit_price: 2235.91,
          profit: -5.36,
          accum_profit_percentage: 123.59,
        },
      ],
    },
    quantum_apr: {
      info: {
        total_orders: 1480,
        daily_average_trades: 4.07,
        min_balance: 1006.0,
        max_balance: 17632.0,
        absolute_drawdown: 29.28,
        sharpe_ratio: 5.69,
      },
      data: [
        {
          month: "January",
          total_profit: 82.35,
          accum_profit_price: 1082.35,
          profit: 8.24,
          accum_profit_percentage: 8.23,
        },
        {
          month: "February",
          total_profit: 11.49,
          accum_profit_price: 1070.86,
          profit: -1.06,
          accum_profit_percentage: 7.09,
        },
        {
          month: "March",
          total_profit: 54.47,
          accum_profit_price: 1016.39,
          profit: -5.09,
          accum_profit_percentage: 1.64,
        },
        {
          month: "April",
          total_profit: 69.1,
          accum_profit_price: 1085.49,
          profit: 6.8,
          accum_profit_percentage: 8.55,
        },
        {
          month: "May",
          total_profit: 1.15,
          accum_profit_price: 1084.34,
          profit: -0.11,
          accum_profit_percentage: 8.43,
        },
        {
          month: "June",
          total_profit: 96.97,
          accum_profit_price: 1181.31,
          profit: 8.94,
          accum_profit_percentage: 18.13,
        },
        {
          month: "July",
          total_profit: 392.37,
          accum_profit_price: 1573.68,
          profit: 33.21,
          accum_profit_percentage: 57.37,
        },
        {
          month: "August",
          total_profit: 420.55,
          accum_profit_price: 1994.23,
          profit: 26.72,
          accum_profit_percentage: 99.42,
        },
        {
          month: "September",
          total_profit: 20.17,
          accum_profit_price: 1974.06,
          profit: -1.01,
          accum_profit_percentage: 97.41,
        },
        {
          month: "October",
          total_profit: 54.75,
          accum_profit_price: 1919.31,
          profit: -2.77,
          accum_profit_percentage: 91.93,
        },
        {
          month: "November",
          total_profit: 60.93,
          accum_profit_price: 1858.38,
          profit: -3.17,
          accum_profit_percentage: 85.84,
        },
        {
          month: "December",
          total_profit: 185.35,
          accum_profit_price: 2043.73,
          profit: 9.97,
          accum_profit_percentage: 104.37,
        },
      ],
    },
  },
  "2021": {
    smart_flow: {
      info: {
        total_orders: 1115,
        daily_average_trades: 3.06,
        min_balance: 998.56,
        max_balance: 4296.5,
        absolute_drawdown: 34.34,
        sharpe_ratio: 4.8,
      },
      data: [
        {
          month: "January",
          total_profit: 449.45,
          accum_profit_price: 1449.45,
          profit: 44.95,
          accum_profit_percentage: 44.95,
        },
        {
          month: "February",
          total_profit: 839.77,
          accum_profit_price: 2289.22,
          profit: 57.94,
          accum_profit_percentage: 128.92,
        },
        {
          month: "March",
          total_profit: 166.53,
          accum_profit_price: 2455.75,
          profit: 7.27,
          accum_profit_percentage: 145.58,
        },
        {
          month: "April",
          total_profit: 323.12,
          accum_profit_price: 2778.87,
          profit: 13.16,
          accum_profit_percentage: 177.89,
        },
        {
          month: "May",
          total_profit: 259.99,
          accum_profit_price: 2518.88,
          profit: -9.36,
          accum_profit_percentage: 151.89,
        },
        {
          month: "June",
          total_profit: 227.53,
          accum_profit_price: 2746.41,
          profit: 9.03,
          accum_profit_percentage: 174.64,
        },
        {
          month: "July",
          total_profit: 132.46,
          accum_profit_price: 2878.87,
          profit: 4.82,
          accum_profit_percentage: 187.89,
        },
        {
          month: "August",
          total_profit: 1127.13,
          accum_profit_price: 4006.0,
          profit: 39.15,
          accum_profit_percentage: 300.6,
        },
        {
          month: "September",
          total_profit: 474.15,
          accum_profit_price: 3531.85,
          profit: -11.84,
          accum_profit_percentage: 253.19,
        },
        {
          month: "October",
          total_profit: 356.51,
          accum_profit_price: 3888.36,
          profit: 10.09,
          accum_profit_percentage: 288.84,
        },
        {
          month: "November",
          total_profit: 56.73,
          accum_profit_price: 3945.09,
          profit: 1.46,
          accum_profit_percentage: 294.51,
        },
        {
          month: "December",
          total_profit: 193.77,
          accum_profit_price: 3751.32,
          profit: -4.91,
          accum_profit_percentage: 275.13,
        },
      ],
    },
    candle_master: {
      info: {
        total_orders: 1393,
        daily_average_trades: 3.83,
        min_balance: 1000.0,
        max_balance: 26128.0,
        absolute_drawdown: 48.76,
        sharpe_ratio: 6.53,
      },
      data: [
        {
          month: "January",
          total_profit: 981.78,
          accum_profit_price: 1981.78,
          profit: 98.18,
          accum_profit_percentage: 98.18,
        },
        {
          month: "February",
          total_profit: 374.67,
          accum_profit_price: 2356.45,
          profit: 18.91,
          accum_profit_percentage: 135.65,
        },
        {
          month: "March",
          total_profit: 1664.17,
          accum_profit_price: 4020.62,
          profit: 70.62,
          accum_profit_percentage: 302.06,
        },
        {
          month: "April",
          total_profit: 2681.41,
          accum_profit_price: 6702.03,
          profit: 66.69,
          accum_profit_percentage: 570.2,
        },
        {
          month: "May",
          total_profit: 850.34,
          accum_profit_price: 5851.69,
          profit: -12.69,
          accum_profit_percentage: 485.17,
        },
        {
          month: "June",
          total_profit: 619.39,
          accum_profit_price: 5232.3,
          profit: -10.58,
          accum_profit_percentage: 423.23,
        },
        {
          month: "July",
          total_profit: 2826.96,
          accum_profit_price: 8059.26,
          profit: 54.03,
          accum_profit_percentage: 705.93,
        },
        {
          month: "August",
          total_profit: 3034.27,
          accum_profit_price: 11093.53,
          profit: 37.65,
          accum_profit_percentage: 1009.35,
        },
        {
          month: "September",
          total_profit: 6775.71,
          accum_profit_price: 17869.24,
          profit: 61.08,
          accum_profit_percentage: 1686.92,
        },
        {
          month: "October",
          total_profit: 5971.72,
          accum_profit_price: 23840.96,
          profit: 33.42,
          accum_profit_percentage: 2284.1,
        },
        {
          month: "November",
          total_profit: 1899.02,
          accum_profit_price: 25739.98,
          profit: 7.97,
          accum_profit_percentage: 2474.0,
        },
        {
          month: "December",
          total_profit: 399.0,
          accum_profit_price: 26138.98,
          profit: 1.55,
          accum_profit_percentage: 2513.9,
        },
      ],
    },
    ewo_strike: {
      info: {
        total_orders: 353,
        daily_average_trades: 0.97,
        min_balance: 1000.0,
        max_balance: 23496.0,
        absolute_drawdown: 56.26,
        sharpe_ratio: 1.87,
      },
      data: [
        {
          month: "January",
          total_profit: 1482.97,
          accum_profit_price: 2482.97,
          profit: 148.3,
          accum_profit_percentage: 148.3,
        },
        {
          month: "February",
          total_profit: 3633.65,
          accum_profit_price: 6116.62,
          profit: 146.34,
          accum_profit_percentage: 511.66,
        },
        {
          month: "March",
          total_profit: 1763.22,
          accum_profit_price: 7879.84,
          profit: 28.83,
          accum_profit_percentage: 687.98,
        },
        {
          month: "April",
          total_profit: 5963.91,
          accum_profit_price: 13843.75,
          profit: 75.69,
          accum_profit_percentage: 1284.38,
        },
        {
          month: "May",
          total_profit: 6459.95,
          accum_profit_price: 7383.8,
          profit: -46.66,
          accum_profit_percentage: 638.38,
        },
        {
          month: "June",
          total_profit: 559.65,
          accum_profit_price: 7943.45,
          profit: 7.58,
          accum_profit_percentage: 694.35,
        },
        {
          month: "July",
          total_profit: 351.15,
          accum_profit_price: 8294.6,
          profit: 4.42,
          accum_profit_percentage: 729.46,
        },
        {
          month: "August",
          total_profit: 4589.07,
          accum_profit_price: 12883.67,
          profit: 55.33,
          accum_profit_percentage: 1188.37,
        },
        {
          month: "September",
          total_profit: 7102.95,
          accum_profit_price: 19986.62,
          profit: 55.13,
          accum_profit_percentage: 1898.66,
        },
        {
          month: "October",
          total_profit: 3508.58,
          accum_profit_price: 23495.2,
          profit: 17.55,
          accum_profit_percentage: 2249.52,
        },
        {
          month: "November",
          total_profit: 83.63,
          accum_profit_price: 23411.57,
          profit: -0.36,
          accum_profit_percentage: 2241.16,
        },
        {
          month: "December",
          total_profit: 6375.72,
          accum_profit_price: 17035.85,
          profit: -27.23,
          accum_profit_percentage: 1603.59,
        },
      ],
    },
    quantum_apr: {
      info: {
        total_orders: 1480,
        daily_average_trades: 4.07,
        min_balance: 1006.0,
        max_balance: 17632.0,
        absolute_drawdown: 29.28,
        sharpe_ratio: 5.69,
      },
      data: [
        {
          month: "January",
          total_profit: 809.12,
          accum_profit_price: 1809.12,
          profit: 80.91,
          accum_profit_percentage: 80.91,
        },
        {
          month: "February",
          total_profit: 617.44,
          accum_profit_price: 2426.56,
          profit: 34.13,
          accum_profit_percentage: 142.66,
        },
        {
          month: "March",
          total_profit: 1493.07,
          accum_profit_price: 3919.63,
          profit: 61.53,
          accum_profit_percentage: 291.96,
        },
        {
          month: "April",
          total_profit: 1396.56,
          accum_profit_price: 5316.19,
          profit: 35.63,
          accum_profit_percentage: 431.62,
        },
        {
          month: "May",
          total_profit: 1927.07,
          accum_profit_price: 7243.26,
          profit: 36.25,
          accum_profit_percentage: 624.33,
        },
        {
          month: "June",
          total_profit: 126.87,
          accum_profit_price: 7370.13,
          profit: 1.75,
          accum_profit_percentage: 637.01,
        },
        {
          month: "July",
          total_profit: 195.1,
          accum_profit_price: 7565.23,
          profit: 2.65,
          accum_profit_percentage: 656.52,
        },
        {
          month: "August",
          total_profit: 3537.73,
          accum_profit_price: 11102.96,
          profit: 46.76,
          accum_profit_percentage: 1010.3,
        },
        {
          month: "September",
          total_profit: 2365.77,
          accum_profit_price: 13468.73,
          profit: 21.31,
          accum_profit_percentage: 1246.87,
        },
        {
          month: "October",
          total_profit: 3250.02,
          accum_profit_price: 16718.75,
          profit: 24.13,
          accum_profit_percentage: 1571.88,
        },
        {
          month: "November",
          total_profit: 247.8,
          accum_profit_price: 16470.95,
          profit: -1.48,
          accum_profit_percentage: 1547.1,
        },
        {
          month: "December",
          total_profit: 2325.55,
          accum_profit_price: 14145.4,
          profit: -14.12,
          accum_profit_percentage: 1314.54,
        },
      ],
    },
  },
  "2022": {
    smart_flow: {
      info: {
        total_orders: 320,
        daily_average_trades: 0.88,
        min_balance: 943.32,
        max_balance: 1672.72,
        absolute_drawdown: 26.05,
        sharpe_ratio: 2.17,
      },
      data: [
        {
          month: "January",
          total_profit: 95.6,
          accum_profit_price: 1095.6,
          profit: 9.56,
          accum_profit_percentage: 9.56,
        },
        {
          month: "February",
          total_profit: 23.11,
          accum_profit_price: 1118.71,
          profit: 2.11,
          accum_profit_percentage: 11.87,
        },
        {
          month: "March",
          total_profit: 51.77,
          accum_profit_price: 1170.48,
          profit: 4.63,
          accum_profit_percentage: 17.05,
        },
        {
          month: "April",
          total_profit: 8.26,
          accum_profit_price: 1162.22,
          profit: -0.71,
          accum_profit_percentage: 16.22,
        },
        {
          month: "May",
          total_profit: 16.94,
          accum_profit_price: 1179.16,
          profit: 1.46,
          accum_profit_percentage: 17.92,
        },
        {
          month: "June",
          total_profit: 108.57,
          accum_profit_price: 1287.73,
          profit: 9.21,
          accum_profit_percentage: 28.77,
        },
        {
          month: "July",
          total_profit: 35.27,
          accum_profit_price: 1323.0,
          profit: 2.74,
          accum_profit_percentage: 32.3,
        },
        {
          month: "August",
          total_profit: 71.92,
          accum_profit_price: 1394.92,
          profit: 5.44,
          accum_profit_percentage: 39.49,
        },
        {
          month: "September",
          total_profit: 15.15,
          accum_profit_price: 1410.07,
          profit: 1.09,
          accum_profit_percentage: 41.01,
        },
        {
          month: "October",
          total_profit: 5.56,
          accum_profit_price: 1415.63,
          profit: 0.39,
          accum_profit_percentage: 41.56,
        },
        {
          month: "November",
          total_profit: 120.64,
          accum_profit_price: 1536.27,
          profit: 8.52,
          accum_profit_percentage: 53.63,
        },
        {
          month: "December",
          total_profit: 136.45,
          accum_profit_price: 1672.72,
          profit: 8.88,
          accum_profit_percentage: 67.27,
        },
      ],
    },
    candle_master: {
      info: {
        total_orders: 349,
        daily_average_trades: 0.96,
        min_balance: 1000.0,
        max_balance: 1932.1,
        absolute_drawdown: 21.38,
        sharpe_ratio: 2.46,
      },
      data: [
        {
          month: "January",
          total_profit: 93.2,
          accum_profit_price: 1093.2,
          profit: 9.32,
          accum_profit_percentage: 9.32,
        },
        {
          month: "February",
          total_profit: 102.63,
          accum_profit_price: 1195.83,
          profit: 9.39,
          accum_profit_percentage: 19.58,
        },
        {
          month: "March",
          total_profit: 100.76,
          accum_profit_price: 1296.59,
          profit: 8.43,
          accum_profit_percentage: 29.66,
        },
        {
          month: "April",
          total_profit: 19.41,
          accum_profit_price: 1316.0,
          profit: 1.5,
          accum_profit_percentage: 31.6,
        },
        {
          month: "May",
          total_profit: 119.34,
          accum_profit_price: 1196.66,
          profit: -9.07,
          accum_profit_percentage: 19.67,
        },
        {
          month: "June",
          total_profit: 37.45,
          accum_profit_price: 1159.21,
          profit: -3.13,
          accum_profit_percentage: 15.92,
        },
        {
          month: "July",
          total_profit: 217.26,
          accum_profit_price: 1376.47,
          profit: 18.74,
          accum_profit_percentage: 37.65,
        },
        {
          month: "August",
          total_profit: 39.88,
          accum_profit_price: 1336.59,
          profit: -2.9,
          accum_profit_percentage: 33.66,
        },
        {
          month: "September",
          total_profit: 12.84,
          accum_profit_price: 1349.43,
          profit: 0.96,
          accum_profit_percentage: 34.94,
        },
        {
          month: "October",
          total_profit: 31.94,
          accum_profit_price: 1381.37,
          profit: 2.37,
          accum_profit_percentage: 38.14,
        },
        {
          month: "November",
          total_profit: 90.93,
          accum_profit_price: 1472.3,
          profit: 6.58,
          accum_profit_percentage: 47.23,
        },
        {
          month: "December",
          total_profit: 459.81,
          accum_profit_price: 1932.11,
          profit: 31.23,
          accum_profit_percentage: 93.21,
        },
      ],
    },
    ewo_strike: {
      info: {
        total_orders: 604,
        daily_average_trades: 1.66,
        min_balance: 688.51,
        max_balance: 2753.33,
        absolute_drawdown: 35.55,
        sharpe_ratio: 2.58,
      },
      data: [
        {
          month: "January",
          total_profit: 123.98,
          accum_profit_price: 876.02,
          profit: -12.4,
          accum_profit_percentage: -12.4,
        },
        {
          month: "February",
          total_profit: 87.07,
          accum_profit_price: 963.09,
          profit: 9.94,
          accum_profit_percentage: -3.69,
        },
        {
          month: "March",
          total_profit: 245.86,
          accum_profit_price: 1208.95,
          profit: 25.53,
          accum_profit_percentage: 20.9,
        },
        {
          month: "April",
          total_profit: 55.6,
          accum_profit_price: 1153.35,
          profit: -4.6,
          accum_profit_percentage: 15.34,
        },
        {
          month: "May",
          total_profit: 104.4,
          accum_profit_price: 1048.95,
          profit: -9.05,
          accum_profit_percentage: 4.89,
        },
        {
          month: "June",
          total_profit: 37.4,
          accum_profit_price: 1086.35,
          profit: 3.57,
          accum_profit_percentage: 8.63,
        },
        {
          month: "July",
          total_profit: 332.12,
          accum_profit_price: 1418.47,
          profit: 30.57,
          accum_profit_percentage: 41.85,
        },
        {
          month: "August",
          total_profit: 393.12,
          accum_profit_price: 1811.59,
          profit: 27.71,
          accum_profit_percentage: 81.16,
        },
        {
          month: "September",
          total_profit: 269.99,
          accum_profit_price: 2081.58,
          profit: 14.9,
          accum_profit_percentage: 108.16,
        },
        {
          month: "October",
          total_profit: 138.53,
          accum_profit_price: 2220.11,
          profit: 6.66,
          accum_profit_percentage: 122.01,
        },
        {
          month: "November",
          total_profit: 37.0,
          accum_profit_price: 2183.11,
          profit: -1.67,
          accum_profit_percentage: 118.31,
        },
        {
          month: "December",
          total_profit: 570.24,
          accum_profit_price: 2753.35,
          profit: 26.12,
          accum_profit_percentage: 175.33,
        },
      ],
    },
    quantum_apr: {
      info: {
        total_orders: 70,
        daily_average_trades: 0.19,
        min_balance: 1000.0,
        max_balance: 1742.0,
        absolute_drawdown: 4.08,
        sharpe_ratio: 3.02,
      },
      data: [
        {
          month: "January",
          total_profit: 126.41,
          accum_profit_price: 1126.41,
          profit: 12.64,
          accum_profit_percentage: 12.64,
        },
        {
          month: "February",
          total_profit: 27.95,
          accum_profit_price: 1154.36,
          profit: 2.48,
          accum_profit_percentage: 15.44,
        },
        {
          month: "March",
          total_profit: 11.45,
          accum_profit_price: 1165.81,
          profit: 0.99,
          accum_profit_percentage: 16.58,
        },
        {
          month: "April",
          total_profit: 46.13,
          accum_profit_price: 1211.94,
          profit: 3.96,
          accum_profit_percentage: 21.19,
        },
        {
          month: "May",
          total_profit: 134.04,
          accum_profit_price: 1345.98,
          profit: 11.06,
          accum_profit_percentage: 34.6,
        },
        {
          month: "June",
          total_profit: 67.88,
          accum_profit_price: 1413.86,
          profit: 5.04,
          accum_profit_percentage: 41.39,
        },
        {
          month: "July",
          total_profit: 37.26,
          accum_profit_price: 1451.12,
          profit: 2.64,
          accum_profit_percentage: 45.11,
        },
        {
          month: "August",
          total_profit: 15.31,
          accum_profit_price: 1466.43,
          profit: 1.06,
          accum_profit_percentage: 46.64,
        },
        {
          month: "September",
          total_profit: 38.88,
          accum_profit_price: 1427.56,
          profit: -2.65,
          accum_profit_percentage: 42.76,
        },
        {
          month: "October",
          total_profit: 0,
          accum_profit_price: 1427.56,
          profit: 0,
          accum_profit_percentage: 42.76,
        },
        {
          month: "November",
          total_profit: 260.74,
          accum_profit_price: 1688.3,
          profit: 18.26,
          accum_profit_percentage: 68.83,
        },
        {
          month: "December",
          total_profit: 53.83,
          accum_profit_price: 1742.13,
          profit: 3.19,
          accum_profit_percentage: 74.21,
        },
      ],
    },
  },
  "2023": {
    smart_flow: {
      info: {
        total_orders: 507,
        daily_average_trades: 1.39,
        min_balance: 1000.0,
        max_balance: 2363.0,
        absolute_drawdown: 9.6,
        sharpe_ratio: 7.55,
      },
      data: [
        {
          month: "January",
          total_profit: 344.05,
          accum_profit_price: 1344.05,
          profit: 34.4,
          accum_profit_percentage: 34.4,
        },
        {
          month: "February",
          total_profit: 13.12,
          accum_profit_price: 1357.17,
          profit: 0.98,
          accum_profit_percentage: 35.72,
        },
        {
          month: "March",
          total_profit: 31.1,
          accum_profit_price: 1388.27,
          profit: 2.29,
          accum_profit_percentage: 38.83,
        },
        {
          month: "April",
          total_profit: 3.47,
          accum_profit_price: 1391.74,
          profit: 0.25,
          accum_profit_percentage: 39.17,
        },
        {
          month: "May",
          total_profit: 5.45,
          accum_profit_price: 1397.2,
          profit: 0.39,
          accum_profit_percentage: 39.72,
        },
        {
          month: "June",
          total_profit: 121.5,
          accum_profit_price: 1518.69,
          profit: 8.7,
          accum_profit_percentage: 51.87,
        },
        {
          month: "July",
          total_profit: 100.76,
          accum_profit_price: 1619.45,
          profit: 6.63,
          accum_profit_percentage: 61.95,
        },
        {
          month: "August",
          total_profit: 1.0,
          accum_profit_price: 1618.46,
          profit: -0.06,
          accum_profit_percentage: 61.85,
        },
        {
          month: "September",
          total_profit: 16.81,
          accum_profit_price: 1635.27,
          profit: 1.04,
          accum_profit_percentage: 63.53,
        },
        {
          month: "October",
          total_profit: 82.78,
          accum_profit_price: 1718.05,
          profit: 5.06,
          accum_profit_percentage: 71.8,
        },
        {
          month: "November",
          total_profit: 110.0,
          accum_profit_price: 1828.05,
          profit: 6.4,
          accum_profit_percentage: 82.8,
        },
        {
          month: "December",
          total_profit: 514.23,
          accum_profit_price: 2342.28,
          profit: 28.13,
          accum_profit_percentage: 134.23,
        },
      ],
    },
    candle_master: {
      info: {
        total_orders: 448,
        daily_average_trades: 1.23,
        min_balance: 1000.0,
        max_balance: 5026.73,
        absolute_drawdown: 15.3,
        sharpe_ratio: 8.4,
      },
      data: [
        {
          month: "January",
          total_profit: 1061.27,
          accum_profit_price: 2061.27,
          profit: 106.13,
          accum_profit_percentage: 106.13,
        },
        {
          month: "February",
          total_profit: 226.56,
          accum_profit_price: 2287.83,
          profit: 10.99,
          accum_profit_percentage: 128.78,
        },
        {
          month: "March",
          total_profit: 220.42,
          accum_profit_price: 2508.25,
          profit: 9.63,
          accum_profit_percentage: 150.83,
        },
        {
          month: "April",
          total_profit: 32.38,
          accum_profit_price: 2540.63,
          profit: 1.29,
          accum_profit_percentage: 154.06,
        },
        {
          month: "May",
          total_profit: 6.79,
          accum_profit_price: 2547.42,
          profit: 0.27,
          accum_profit_percentage: 154.74,
        },
        {
          month: "June",
          total_profit: 217.27,
          accum_profit_price: 2764.69,
          profit: 8.53,
          accum_profit_percentage: 176.47,
        },
        {
          month: "July",
          total_profit: 151.35,
          accum_profit_price: 2613.34,
          profit: -5.47,
          accum_profit_percentage: 161.33,
        },
        {
          month: "August",
          total_profit: 65.19,
          accum_profit_price: 2678.53,
          profit: 2.49,
          accum_profit_percentage: 167.85,
        },
        {
          month: "September",
          total_profit: 0,
          accum_profit_price: 2678.53,
          profit: 0,
          accum_profit_percentage: 167.85,
        },
        {
          month: "October",
          total_profit: 400.74,
          accum_profit_price: 3079.27,
          profit: 14.96,
          accum_profit_percentage: 207.93,
        },
        {
          month: "November",
          total_profit: 685.1,
          accum_profit_price: 3764.37,
          profit: 22.25,
          accum_profit_percentage: 276.44,
        },
        {
          month: "December",
          total_profit: 1262.34,
          accum_profit_price: 5026.71,
          profit: 33.53,
          accum_profit_percentage: 402.67,
        },
      ],
    },
    ewo_strike: {
      info: {
        total_orders: 117,
        daily_average_trades: 0.32,
        min_balance: 1000.0,
        max_balance: 3825.0,
        absolute_drawdown: 19.53,
        sharpe_ratio: 4.19,
      },
      data: [
        {
          month: "January",
          total_profit: 844.13,
          accum_profit_price: 1844.13,
          profit: 84.41,
          accum_profit_percentage: 84.41,
        },
        {
          month: "February",
          total_profit: 212.13,
          accum_profit_price: 1632.0,
          profit: -11.5,
          accum_profit_percentage: 63.2,
        },
        {
          month: "March",
          total_profit: 152.9,
          accum_profit_price: 1784.9,
          profit: 9.37,
          accum_profit_percentage: 78.49,
        },
        {
          month: "April",
          total_profit: 0,
          accum_profit_price: 1784.9,
          profit: 0,
          accum_profit_percentage: 78.49,
        },
        {
          month: "May",
          total_profit: 0,
          accum_profit_price: 1784.9,
          profit: 0,
          accum_profit_percentage: 78.49,
        },
        {
          month: "June",
          total_profit: 173.27,
          accum_profit_price: 1958.17,
          profit: 9.71,
          accum_profit_percentage: 95.82,
        },
        {
          month: "July",
          total_profit: 49.06,
          accum_profit_price: 2007.23,
          profit: 2.51,
          accum_profit_percentage: 100.72,
        },
        {
          month: "August",
          total_profit: 0,
          accum_profit_price: 2007.23,
          profit: 0,
          accum_profit_percentage: 100.72,
        },
        {
          month: "September",
          total_profit: 0,
          accum_profit_price: 2007.23,
          profit: 0,
          accum_profit_percentage: 100.72,
        },
        {
          month: "October",
          total_profit: 431.88,
          accum_profit_price: 2439.11,
          profit: 21.52,
          accum_profit_percentage: 143.91,
        },
        {
          month: "November",
          total_profit: 807.01,
          accum_profit_price: 3246.12,
          profit: 33.09,
          accum_profit_percentage: 224.61,
        },
        {
          month: "December",
          total_profit: 579.34,
          accum_profit_price: 3825.46,
          profit: 17.85,
          accum_profit_percentage: 282.55,
        },
      ],
    },
    quantum_apr: {
      info: {
        total_orders: 565,
        daily_average_trades: 1.55,
        min_balance: 971.36,
        max_balance: 2620.6,
        absolute_drawdown: 10.3,
        sharpe_ratio: 5.7,
      },
      data: [
        {
          month: "January",
          total_profit: 377.72,
          accum_profit_price: 1377.72,
          profit: 37.77,
          accum_profit_percentage: 37.77,
        },
        {
          month: "February",
          total_profit: 102.87,
          accum_profit_price: 1480.59,
          profit: 7.47,
          accum_profit_percentage: 48.06,
        },
        {
          month: "March",
          total_profit: 103.09,
          accum_profit_price: 1583.68,
          profit: 6.96,
          accum_profit_percentage: 58.37,
        },
        {
          month: "April",
          total_profit: 16.19,
          accum_profit_price: 1599.87,
          profit: 1.02,
          accum_profit_percentage: 59.99,
        },
        {
          month: "May",
          total_profit: 85.27,
          accum_profit_price: 1685.14,
          profit: 5.33,
          accum_profit_percentage: 68.51,
        },
        {
          month: "June",
          total_profit: 17.88,
          accum_profit_price: 1703.02,
          profit: 1.06,
          accum_profit_percentage: 70.3,
        },
        {
          month: "July",
          total_profit: 2.13,
          accum_profit_price: 1700.89,
          profit: -0.13,
          accum_profit_percentage: 70.09,
        },
        {
          month: "August",
          total_profit: 47.48,
          accum_profit_price: 1748.37,
          profit: 2.79,
          accum_profit_percentage: 74.84,
        },
        {
          month: "September",
          total_profit: 6.39,
          accum_profit_price: 1754.76,
          profit: 0.37,
          accum_profit_percentage: 75.48,
        },
        {
          month: "October",
          total_profit: 293.38,
          accum_profit_price: 2048.14,
          profit: 16.72,
          accum_profit_percentage: 104.81,
        },
        {
          month: "November",
          total_profit: 168.08,
          accum_profit_price: 2216.22,
          profit: 8.21,
          accum_profit_percentage: 121.62,
        },
        {
          month: "December",
          total_profit: 362.41,
          accum_profit_price: 2578.63,
          profit: 16.35,
          accum_profit_percentage: 157.86,
        },
      ],
    },
  },
  "2024": {
    smart_flow: {
      info: {
        total_orders: 301,
        daily_average_trades: 0.82,
        min_balance: 794.31,
        max_balance: 1128.13,
        absolute_drawdown: 29.59,
        sharpe_ratio: 0.04,
      },
      data: [
        {
          month: "January",
          total_profit: 27.67,
          accum_profit_price: 1027.67,
          profit: 2.77,
          accum_profit_percentage: 2.77,
        },
        {
          month: "February",
          total_profit: 72.28,
          accum_profit_price: 1099.95,
          profit: 7.03,
          accum_profit_percentage: 10.0,
        },
        {
          month: "March",
          total_profit: 157.14,
          accum_profit_price: 1257.09,
          profit: 14.29,
          accum_profit_percentage: 25.71,
        },
        {
          month: "April",
          total_profit: 25.78,
          accum_profit_price: 1282.87,
          profit: 2.05,
          accum_profit_percentage: 28.29,
        },
        {
          month: "May",
          total_profit: 10.91,
          accum_profit_price: 1293.78,
          profit: 0.85,
          accum_profit_percentage: 29.38,
        },
        {
          month: "June",
          total_profit: 4.06,
          accum_profit_price: 1297.84,
          profit: 0.31,
          accum_profit_percentage: 29.78,
        },
        {
          month: "July",
          total_profit: 26.32,
          accum_profit_price: 1324.16,
          profit: 2.03,
          accum_profit_percentage: 32.42,
        },
        {
          month: "August",
          total_profit: 28.71,
          accum_profit_price: 1352.87,
          profit: 2.17,
          accum_profit_percentage: 35.29,
        },
        {
          month: "September",
          total_profit: 113.66,
          accum_profit_price: 1466.53,
          profit: 8.4,
          accum_profit_percentage: 46.65,
        },
        {
          month: "October",
          total_profit: 33.9,
          accum_profit_price: 1500.43,
          profit: 2.31,
          accum_profit_percentage: 50.04,
        },
        {
          month: "November",
          total_profit: 615.57,
          accum_profit_price: 2116.0,
          profit: 41.03,
          accum_profit_percentage: 111.6,
        },
        {
          month: "December",
          total_profit: 132.1,
          accum_profit_price: 2248.1,
          profit: 6.24,
          accum_profit_percentage: 124.81,
        },
      ],
    },
    candle_master: {
      info: {
        total_orders: 507,
        daily_average_trades: 1.39,
        min_balance: 1000.0,
        max_balance: 2363.0,
        absolute_drawdown: 9.6,
        sharpe_ratio: 7.55,
      },
      data: [
        {
          month: "January",
          total_profit: 350.45,
          accum_profit_price: 1350.45,
          profit: 35.05,
          accum_profit_percentage: 35.05,
        },
        {
          month: "February",
          total_profit: 198.56,
          accum_profit_price: 1549.01,
          profit: 14.7,
          accum_profit_percentage: 54.9,
        },
        {
          month: "March",
          total_profit: 177.34,
          accum_profit_price: 1726.35,
          profit: 11.45,
          accum_profit_percentage: 72.64,
        },
        {
          month: "April",
          total_profit: 144.21,
          accum_profit_price: 1582.14,
          profit: -8.35,
          accum_profit_percentage: 58.21,
        },
        {
          month: "May",
          total_profit: 174.93,
          accum_profit_price: 1757.07,
          profit: 11.06,
          accum_profit_percentage: 75.71,
        },
        {
          month: "June",
          total_profit: 7.73,
          accum_profit_price: 1749.34,
          profit: -0.44,
          accum_profit_percentage: 74.93,
        },
        {
          month: "July",
          total_profit: 49.26,
          accum_profit_price: 1700.08,
          profit: -2.82,
          accum_profit_percentage: 70.01,
        },
        {
          month: "August",
          total_profit: 28.47,
          accum_profit_price: 1728.55,
          profit: 1.67,
          accum_profit_percentage: 72.86,
        },
        {
          month: "September",
          total_profit: 346.52,
          accum_profit_price: 2075.07,
          profit: 20.05,
          accum_profit_percentage: 107.51,
        },
        {
          month: "October",
          total_profit: 512.93,
          accum_profit_price: 2588.0,
          profit: 24.72,
          accum_profit_percentage: 158.8,
        },
        {
          month: "November",
          total_profit: 26.71,
          accum_profit_price: 2561.29,
          profit: -1.03,
          accum_profit_percentage: 156.13,
        },
        {
          month: "December",
          total_profit: 68.6,
          accum_profit_price: 2629.89,
          profit: 2.68,
          accum_profit_percentage: 162.99,
        },
      ],
    },
    ewo_strike: {
      info: {
        total_orders: 136,
        daily_average_trades: 0.37,
        min_balance: 1000.0,
        max_balance: 1881.36,
        absolute_drawdown: 2.87,
        sharpe_ratio: 8.19,
      },
      data: [
        {
          month: "January",
          total_profit: 56.47,
          accum_profit_price: 1056.47,
          profit: 5.65,
          accum_profit_percentage: 5.65,
        },
        {
          month: "February",
          total_profit: 45.96,
          accum_profit_price: 1102.43,
          profit: 4.35,
          accum_profit_percentage: 10.24,
        },
        {
          month: "March",
          total_profit: 97.09,
          accum_profit_price: 1199.52,
          profit: 8.81,
          accum_profit_percentage: 19.95,
        },
        {
          month: "April",
          total_profit: 73.85,
          accum_profit_price: 1273.37,
          profit: 6.16,
          accum_profit_percentage: 27.34,
        },
        {
          month: "May",
          total_profit: 2.94,
          accum_profit_price: 1276.31,
          profit: 0.23,
          accum_profit_percentage: 27.63,
        },
        {
          month: "June",
          total_profit: 0,
          accum_profit_price: 1276.31,
          profit: 0,
          accum_profit_percentage: 27.63,
        },
        {
          month: "July",
          total_profit: 7.15,
          accum_profit_price: 1283.46,
          profit: 0.56,
          accum_profit_percentage: 28.35,
        },
        {
          month: "August",
          total_profit: 86.24,
          accum_profit_price: 1369.7,
          profit: 6.72,
          accum_profit_percentage: 36.97,
        },
        {
          month: "September",
          total_profit: 22.37,
          accum_profit_price: 1392.07,
          profit: 1.63,
          accum_profit_percentage: 39.21,
        },
        {
          month: "October",
          total_profit: 0,
          accum_profit_price: 1392.07,
          profit: 0,
          accum_profit_percentage: 39.21,
        },
        {
          month: "November",
          total_profit: 317.75,
          accum_profit_price: 1709.82,
          profit: 22.83,
          accum_profit_percentage: 70.98,
        },
        {
          month: "December",
          total_profit: 171.52,
          accum_profit_price: 1881.34,
          profit: 10.03,
          accum_profit_percentage: 88.13,
        },
      ],
    },
    quantum_apr: {
      info: {
        total_orders: 301,
        daily_average_trades: 0.82,
        min_balance: 794.31,
        max_balance: 1128.13,
        absolute_drawdown: 29.59,
        sharpe_ratio: 0.04,
      },
      data: [
        {
          month: "January",
          total_profit: 14.57,
          accum_profit_price: 985.43,
          profit: -1.46,
          accum_profit_percentage: -1.46,
        },
        {
          month: "February",
          total_profit: 25.91,
          accum_profit_price: 1011.34,
          profit: 2.63,
          accum_profit_percentage: 1.13,
        },
        {
          month: "March",
          total_profit: 110.68,
          accum_profit_price: 1122.02,
          profit: 10.94,
          accum_profit_percentage: 12.2,
        },
        {
          month: "April",
          total_profit: 269.85,
          accum_profit_price: 852.17,
          profit: -24.05,
          accum_profit_percentage: -14.78,
        },
        {
          month: "May",
          total_profit: 29.98,
          accum_profit_price: 882.15,
          profit: 3.52,
          accum_profit_percentage: -11.79,
        },
        {
          month: "June",
          total_profit: 69.57,
          accum_profit_price: 812.58,
          profit: -7.89,
          accum_profit_percentage: -18.74,
        },
        {
          month: "July",
          total_profit: 26.48,
          accum_profit_price: 839.06,
          profit: 3.26,
          accum_profit_percentage: -16.09,
        },
        {
          month: "August",
          total_profit: 25.45,
          accum_profit_price: 864.51,
          profit: 3.03,
          accum_profit_percentage: -13.55,
        },
        {
          month: "September",
          total_profit: 2.13,
          accum_profit_price: 866.64,
          profit: 0.25,
          accum_profit_percentage: -13.34,
        },
        {
          month: "October",
          total_profit: 17.42,
          accum_profit_price: 849.22,
          profit: -2.01,
          accum_profit_percentage: -15.08,
        },
        {
          month: "November",
          total_profit: 158.95,
          accum_profit_price: 1008.17,
          profit: 18.72,
          accum_profit_percentage: 0.82,
        },
        {
          month: "December",
          total_profit: 3.03,
          accum_profit_price: 1011.2,
          profit: 0.3,
          accum_profit_percentage: 1.12,
        },
      ],
    },
  },
};
